import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  page: 1,
  perPage: 10,
  count: 0,
  isLoading: false,
  isError: false,
  error: "",

  selectedAnnouncement: null,
  isLoadingDetails: false,

  isAdding: false,
  isAddSuccess: false,

  isUpdating: false,
  isUpdateSuccess: false,

  isDeleting: false,
  isDeleteSuccess: false,

  stats: null,
  isLoadingStats: false,

  isResettingRecipients: false,
  isResetRecipientsSuccess: false,
};

const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    getAnnouncements: (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = "";
    },
    getAnnouncementsSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload?.rows || [];
      state.count = action.payload?.count || 0;
      state.page = Number(action.payload?.page) || 1;
      state.perPage = Number(action.payload?.perPage) || 10;
      state.isError = false;
      state.error = "";
    },
    getAnnouncementsFailed: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload || "Failed to fetch announcements";
    },

    getAnnouncementDetails: (state) => {
      state.isLoadingDetails = true;
    },
    getAnnouncementDetailsSuccess: (state, action) => {
      state.isLoadingDetails = false;
      state.selectedAnnouncement = action.payload;
    },
    getAnnouncementDetailsFailed: (state, action) => {
      state.isLoadingDetails = false;
      state.error = action.payload || "Failed to fetch details";
    },

    createAnnouncement: (state) => {
      state.isAdding = true;
      state.isAddSuccess = false;
    },
    createAnnouncementSuccess: (state, action) => {
      state.isAdding = false;
      state.isAddSuccess = true;
      if (action.payload) {
        state.data = [action.payload, ...state.data];
        state.count += 1;
      }
    },
    createAnnouncementFailed: (state, action) => {
      state.isAdding = false;
      state.isAddSuccess = false;
      state.error = action.payload;
    },
    resetCreateAnnouncement: (state) => {
      state.isAdding = false;
      state.isAddSuccess = false;
    },

    updateAnnouncement: (state) => {
      state.isUpdating = true;
      state.isUpdateSuccess = false;
    },
    updateAnnouncementSuccess: (state, action) => {
      state.isUpdating = false;
      state.isUpdateSuccess = true;
      const updated = action.payload;
      if (updated?.id) {
        state.data = state.data.map((item) => (item.id === updated.id ? { ...item, ...updated } : item));
      }
    },
    updateAnnouncementFailed: (state, action) => {
      state.isUpdating = false;
      state.isUpdateSuccess = false;
      state.error = action.payload;
    },
    resetUpdateAnnouncement: (state) => {
      state.isUpdating = false;
      state.isUpdateSuccess = false;
    },

    deleteAnnouncement: (state) => {
      state.isDeleting = true;
      state.isDeleteSuccess = false;
    },
    deleteAnnouncementSuccess: (state, action) => {
      state.isDeleting = false;
      state.isDeleteSuccess = true;
      const id = action.payload;
      state.data = state.data.filter((item) => item.id !== id);
      state.count = Math.max(0, state.count - 1);
    },
    deleteAnnouncementFailed: (state, action) => {
      state.isDeleting = false;
      state.isDeleteSuccess = false;
      state.error = action.payload;
    },
    resetDeleteAnnouncement: (state) => {
      state.isDeleting = false;
      state.isDeleteSuccess = false;
    },

    getAnnouncementStats: (state) => {
      state.isLoadingStats = true;
      state.stats = null;
    },
    getAnnouncementStatsSuccess: (state, action) => {
      state.isLoadingStats = false;
      state.stats = action.payload;
    },
    getAnnouncementStatsFailed: (state, action) => {
      state.isLoadingStats = false;
      state.error = action.payload;
    },
    resetAnnouncementStats: (state) => {
      state.isLoadingStats = false;
      state.stats = null;
    },

    resetAnnouncementRecipients: (state) => {
      state.isResettingRecipients = true;
      state.isResetRecipientsSuccess = false;
    },
    resetAnnouncementRecipientsSuccess: (state) => {
      state.isResettingRecipients = false;
      state.isResetRecipientsSuccess = true;
    },
    resetAnnouncementRecipientsFailed: (state, action) => {
      state.isResettingRecipients = false;
      state.isResetRecipientsSuccess = false;
      state.error = action.payload;
    },
    resetResetRecipientsStatus: (state) => {
      state.isResettingRecipients = false;
      state.isResetRecipientsSuccess = false;
    },
  },
});

export const {
  getAnnouncements,
  getAnnouncementsSuccess,
  getAnnouncementsFailed,

  getAnnouncementDetails,
  getAnnouncementDetailsSuccess,
  getAnnouncementDetailsFailed,

  createAnnouncement,
  createAnnouncementSuccess,
  createAnnouncementFailed,
  resetCreateAnnouncement,

  updateAnnouncement,
  updateAnnouncementSuccess,
  updateAnnouncementFailed,
  resetUpdateAnnouncement,

  deleteAnnouncement,
  deleteAnnouncementSuccess,
  deleteAnnouncementFailed,
  resetDeleteAnnouncement,

  getAnnouncementStats,
  getAnnouncementStatsSuccess,
  getAnnouncementStatsFailed,
  resetAnnouncementStats,

  resetAnnouncementRecipients,
  resetAnnouncementRecipientsSuccess,
  resetAnnouncementRecipientsFailed,
  resetResetRecipientsStatus,
} = announcementSlice.actions;

export default announcementSlice.reducer;
